































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Locales } from '../i18n/locales';
import { PlanType } from '../types/PlanType';

import { bus } from '../main';

const core = namespace('core');
const plan = namespace('plan');

@Component
export default class Navigation extends Vue {
  @plan.Getter
  public currentPlan!: PlanType;

  @core.State
  private language!: Locales;

  @core.Mutation
  public setLanguage!: (locale: Locales) => void;

  get localeText(): string {
    let newLocale = '';
    switch (this.language) {
      case Locales.DE:
        newLocale = Locales.EN;
        break;
      case Locales.EN:
      default:
        newLocale = Locales.DE;
        break;
    }
    return this.$t('header.changeLocale', { locale: newLocale }) as string;
  }

  // eslint-disable-next-line class-methods-use-this
  private showNotification(): void {
    bus.$emit('onShowNotification', this.$t('notification.noNotifications'));
  }

  // eslint-disable-next-line class-methods-use-this
  private showInformation(): void {
    bus.$emit('onShowNotification', this.$t('notification.welcome'));
  }

  private changeCurrentUser(): void {
    this.$router.push({
      name: 'application.profile',
      params: {
        id: this.$route.params.id === '1' ? '2' : '1',
      },
    });
    bus.$emit('onShowNotification', this.$t('notification.userChanged'));
  }

  private changeLocale(): void {
    if (this.language === Locales.EN) {
      this.setLanguage(Locales.DE);
    } else {
      this.setLanguage(Locales.EN);
    }
  }
}
